


























import { Component, Prop, Vue } from 'vue-property-decorator';
import Details, { Property } from '@/components/Details.vue';
import { UserJson, getFullName } from '@/modules/user';
import { InvoiceJson } from '../json';

@Component<EventDetails>({
  module: 'invoice', // override because it is used in calendar
  filters: {
    fullName(item: UserJson | null, fallbackToId?: boolean): string
    {
      return item ? getFullName(item, fallbackToId) : '';
    },
  },
  methods: {
    getFullName,
  },
  components: {
    Details,
  },
})
export default class EventDetails extends Vue
{
  private showCustomerCommentDialog = false;

  @Prop({ required: true })
  public readonly invoice: InvoiceJson;

  private get properties(): Property[]
  {
    return [
      {
        value: 'invoiceReference',
        title: this.$t('event.details.invoiceReference').toString(),
      },
      {
        value: 'invoiceState',
        title: this.$t('event.details.invoiceState').toString(),
      },
      {
        value: 'businessUnit.name',
        title: this.$t('event.details.businessUnit').toString(),
      },
      {
        value: 'customer',
        title: this.$t('event.details.customer').toString(),
      },
      {
        value: 'invoiceDate',
        title: this.$t('event.details.invoiceDate').toString(),
      },
      {
        value: 'timeForPayment',
        title: this.$t('event.details.timeForPayment').toString(),
      },
    ];
  }
}

